import React, { Component } from 'react';
import vCard from 'vcards-js';
import ACL from 'components/common/ACL'
//import _ from 'lib/lodash'

import Avatar from 'react-md/lib/Avatars';

import FontIcon from 'react-md/lib/FontIcons/FontIcon';
import Card from 'react-md/lib/Cards/Card';
import CardTitle from 'react-md/lib/Cards/CardTitle';
import MenuButton from 'react-md/lib/Menus/MenuButton';
import Button from 'react-md/lib/Buttons'
import ListItem from 'react-md/lib/Lists/ListItem';
import Divider from 'react-md/lib/Dividers'

import TextFieldEdit from 'components/common/TextFieldEdit'

import './ContactCardItem.css'

//	vcardbase64: "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"
function createVCard(properties) {
	const { companyName, role, firstName, lastName /*, pictureUrl, vcardbase64 */ } = properties;
	const { address_street, address_zip, address_city, address_country } = properties;
	const { phone_mobile, email_office, url } = properties;

	const vc = vCard();

	vc.firstName = firstName;
	vc.lastName = lastName;
	vc.organization = companyName;

	vc.workAddress.label = 'Work Address';
	vc.workAddress.street = address_street;
	vc.workAddress.city = address_city;
	vc.workAddress.postalCode = address_zip;
	vc.workAddress.countryRegion = address_country;

	vc.workPhone = phone_mobile;
	vc.title = role;
	vc.email = email_office;
	vc.url = url;

	vc.birthday = new Date();
	vc.anniversary = new Date();

	return vc.getFormattedString();
}


class ContactCardItem extends Component {
	state = {
		isEditing: false
	};

	updateProperty = (property) => {
		const { node, actionHandler } = this.props;
		const { changeNodeProperty } = actionHandler;

		changeNodeProperty(node, property);
	};

	handleMenuEdit = () => this.setState({ ...this.state, isEditing: true });

	handleMenuEditExit = () => {
		const { actionHandler } = this.props;

		this.setState({...this.state, isEditing: false});
		actionHandler.addToast("Änderungen gespeichert");
	};

	handleMenuDelete = e => {
		const { node, actionHandler } = this.props;
		const { deleteNodeFromPayload, addToast } = actionHandler;

		deleteNodeFromPayload(node).then(() => addToast("Kontakt gelöscht"));
	};

	onCall = (raw_number) => window.location.href = `tel:${raw_number}`;

	onEmail = () => {
		const { node } = this.props;
		const { email_office } = node.properties;

		window.location.href = `mailto:${email_office}`;
	};

	onAddToContacts = () => {
		const { node } = this.props;
		const { firstName, lastName } = node.properties;
		const vcardbase64 = btoa(unescape(encodeURIComponent(createVCard(node.properties))));

		const link = document.createElement('a');
		const uri = `data:text/vcard;base64,${vcardbase64}`;
		const filename = `${firstName} ${lastName}.vcf`;

		if (typeof link.download === 'string') {
			link.href = uri;
			link.download = filename;

			// Firefox requires the link to be in the body
			document.body.appendChild(link);

			// simulate click
			link.click();

			// remove the link when done
			document.body.removeChild(link);
		} else {
			window.open(uri, "_self");
		}
	};

	componentDidMount() {
		const { node, aclAllow } = this.props;
		const { properties } = node;

		if (!properties.firstName && !properties.lastName && !properties.companyName && aclAllow.edit !== 'none') this.setState({ isEditing: true});
	}


	/*componentWillUpdate(nextProps, nextState) {
		if (_.isEqual(nextProps.node.properties, this.props.node.properties)) return false;

    const { node } = nextProps;
    const { properties } = node;

    if (this.state.isEditing && properties.firstName)
    	this.setState({ ...this.state, isEditing: false});
	}*/

	render() {
		const { node, aclAllow } = this.props;
		const { companyName, role, firstName, lastName /*, pictureUrl, vcardbase64 */ } = node.properties;
		const { address_street, address_zip, address_city, address_country } = node.properties;
		const { phone_mobile, email_office, url } = node.properties;
		const { isEditing } = this.state;

		const phone_mobile_raw = phone_mobile && phone_mobile.replace(/[^+\d]+/g, "");

		const menuItems = [
			<ListItem
				primaryText="Anrufen"
				key="call"
				leftIcon={<FontIcon>call</FontIcon>}
				onClick={() => this.onCall(phone_mobile_raw)}
			/>,
			<ListItem
				primaryText="Email verfassen"
				key="email"
				leftIcon={<FontIcon>email</FontIcon>}
				onClick={this.onEmail}
			/>,
			<ListItem
				primaryText="Zu Kontakten hinzufügen"
				key="add_contact"
				leftIcon={<FontIcon>person_add</FontIcon>}
				onClick={this.onAddToContacts}
			/>,
			<ACL allow={aclAllow.edit} key="admin">
				<Divider />
				<ListItem
					primaryText="Löschen"
					leftIcon={<FontIcon>delete</FontIcon>}
					onClick={this.handleMenuDelete}
				/>
			</ACL>
		];

		const renderMenu = () => (
			<div className="card-button-container md-cell--right">
				<ACL allow={aclAllow.edit}>
					{ !isEditing && <Button icon onClick={this.handleMenuEdit}>edit</Button> }
					{ isEditing && <Button icon className="icon-done-top" onClick={this.handleMenuEditExit}>done</Button> }
				</ACL>
				<MenuButton
					id={`vert-menu${node.$id}`}
					icon
					menuStyle={{alignSelf: "flex-start"}}
					menuItems={menuItems}
					simplifiedMenu={false}
					anchor={{
						x: MenuButton.HorizontalAnchors.LEFT,
						y: MenuButton.VerticalAnchors.OVERLAP,
					}}
				>
					<FontIcon>more_vert</FontIcon>
				</MenuButton>
			</div>
		);

		const renderContentReadOnly = () => (
			<div>
				<CardTitle
					avatar={<Avatar icon={<FontIcon>person</FontIcon>} suffix="amber" role="presentation" />}
					title={`${firstName} ${lastName}`}
					subtitle={`${role}`}
				>
					{renderMenu()}
				</CardTitle>
				<address className="contact-card-details">
					{ companyName && <span><strong>{companyName}</strong><br/></span> }
					{ address_street && <span>{address_street}<br/></span> }
					{ (address_country || address_zip || address_city) && <span>{`${address_country}-${address_zip} ${address_city}`}<br/></span> }
					{ phone_mobile && <span>Tel: <a href={`tel:${phone_mobile_raw}`}>{phone_mobile}</a><br/></span> }
					{ email_office && <span>Email: <a href={`mailto:${email_office}`}>{email_office}</a><br/></span> }
					{ url && <span>Web: <a href={`${url}`} target="_blank" rel="noopener noreferrer">{url}</a><br/></span> }
				</address>
			</div>
		);

		const renderTextField = (label, property, type) => (
			<div>
				<ACL allow={aclAllow.edit}>
					<TextFieldEdit id={`text-field-${Object.values(property)[0]}`} type={type} label={label} value={Object.values(property)[0]}
					               onSubmit={value => this.updateProperty({[`${Object.keys(property)[0]}`]: value})}
					/>
				</ACL>
				<ACL disallow={aclAllow.edit}>
					{ firstName && <span className="link" onClick={this.handleMenuOpen}>{firstName}</span> }
				</ACL>
			</div>
		);

		const renderContentEdit = () => (
			<div>
				<CardTitle
					avatar={<Avatar icon={<FontIcon>person</FontIcon>} suffix="amber" role="presentation" />}
					title=""
				>
					{renderMenu()}
				</CardTitle>
				<address className="contact-card-details">
					{ renderTextField("Vorname", { firstName }, "title") }
					{ renderTextField("Name", { lastName }, "title") }

					{ renderTextField("Rolle", { role }, "subtitle") }

					{ renderTextField("Firma", { companyName }, "text") }
					{ renderTextField("Adresse", { address_street }, "text") }
					{ renderTextField("Land", { address_country }, "text") }
					{ renderTextField("PLZ", { address_zip }, "text") }
					{ renderTextField("Stadt", { address_city }, "text") }
					{ renderTextField("Telefon", { phone_mobile }, "text") }
					{ renderTextField("Email", { email_office }, "text") }

					{ renderTextField("URL", { url }, "text") }
				</address>
			</div>
		);

		return (
			<Card className="contact-card-item-container">
				<div className="contact-card-content" id={node.$id}>
					{ isEditing && renderContentEdit() }
					{ !isEditing && renderContentReadOnly() }
				</div>
			</Card>
		)
	}
}

export default ContactCardItem;




// WEBPACK FOOTER //
// ./src/components/cards/contact/v1/ContactCardItem.jsx